import { Spin } from "antd";
import React from "react";

export const Spinner = (props) => {
    return (
        <div>
        <Spin/>
      </div>
    );
}